import { openOverlay } from "@kontextwerk/web-sdk/core/overlay/globalStores"
import { newNotification } from "@kontextwerk/web-sdk/core/overlay/notifications"
import { fetchWorkOrders } from "../../../../../../api/kehrblatt/work-orders"
import type { ContactOrderAppointmentRow } from "../../../_logic/contact-orders-contract"
import RecipientQuickEditOverlay from "../_modules/recipient-quick-edit-overlay"
import type { QuickRecipientSaveResult } from "../_shared/_logic/recipient-quick-edit-contract"

export const openRecipientQuickEdit = ({
  organizationId,
  row,
  workOrder,
  customers,
  contactPoints,
  onSaved,
}: {
  organizationId: string
  row: ContactOrderAppointmentRow
  workOrder: WorkOrder | null
  customers: Customer[]
  contactPoints: ContactPoint[]
  onSaved: (result: QuickRecipientSaveResult) => void | Promise<void>
}) => {
  if (!workOrder) {
    newNotification({ class: "error", html: "Für diese Zeile wurde kein Auftrag gefunden." })

    return
  }

  openOverlay({
    title: "Ansprechpartner bearbeiten",
    content: RecipientQuickEditOverlay,
    closeOnParentOpen: false,
    properties: {
      organizationId,
      appointment: row,
      workOrder,
      customers,
      contactPoints,
      onSaved,
    },
  })
}

export const reloadRecipientQuickEditWorkOrders = async ({
  organizationId,
  workOrderIds,
}: {
  organizationId: string
  workOrderIds: string[]
}) => {
  try {
    return await fetchWorkOrders({ organizationId, workOrderIds })
  } catch (err) {
    console.error("contact_order_recipient_quick_edit_work_orders_reload_failed", err)
    newNotification({
      class: "warning",
      html: "Ansprechpartner wurden gespeichert. Die aktualisierten Aufträge konnten nicht sofort neu geladen werden.",
    })

    return []
  }
}
